
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    ISignInItem, ISignInLoading, ISignInLocalAccount, ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/sign-in';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const LocalAccount: React.FC<ISignInLocalAccount> = ({
    localAccount,
    items,
    forgetPassword,
    disclaimer,
    error,
    signInButton
}) => {
    return (
        <Node {...localAccount}>
            {items && items.map((item: ISignInItem) => {
                if (item.key === 'password') {
                    return (
                        <Node key={item.key} {...item.wrapper}>
                            {item.label}
                            {item.error}
                            {item.input}
                            <a
                                id='showPasswordIcon'
                                className='ms-sign-in__password-icon ms-sign-in__password-icon-show'
                                role='button'
                                onClick={_showPassword}
                            />
                        </Node>
                    );
                }
                return (
                    <Node key={item.key} {...item.wrapper}>
                        {item.label}
                        {item.error}
                        {item.input}
                    </Node>
                );
            })}
            {disclaimer}
            {error}
            {signInButton}
            {forgetPassword}
        </Node>
    );
};

const SignInLoading: React.FC<ISignInLoading> = ({
    modal,
    modalBody,
    icon,
    message,
}) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<ISignInViewProps> = props => {

    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        signUpLink
    } = props;

    return (
        <Module {...signIn}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount)}
                </Node>
                <Node {...signUpSection}>
                    {signUpLink}
                </Node>
            </Node>
        </Module>
    );
};

const _showPassword = () => {
    const passwordState = document.getElementById('password') as HTMLInputElement;
    const iconElement = document.getElementById('showPasswordIcon');
    if (passwordState && iconElement) {
        passwordState.type = (passwordState.type === 'password') ? 'text' : 'password';
        iconElement.className = (iconElement.className === 'ms-sign-in__password-icon ms-sign-in__password-icon-show')
            ? 'ms-sign-in__password-icon ms-sign-in__password-icon-hide'
            : 'ms-sign-in__password-icon ms-sign-in__password-icon-show';
    }
};

export default SignInView;
